<template>
  <div class="fund-size-details">基金持仓</div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped></style>
